import { render, staticRenderFns } from "./cancelOfOrder.vue?vue&type=template&id=610735c0&"
import script from "./cancelOfOrder.vue?vue&type=script&lang=js&"
export * from "./cancelOfOrder.vue?vue&type=script&lang=js&"
import style0 from "./cancelOfOrder.vue?vue&type=style&index=0&id=610735c0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('610735c0')) {
      api.createRecord('610735c0', component.options)
    } else {
      api.reload('610735c0', component.options)
    }
    module.hot.accept("./cancelOfOrder.vue?vue&type=template&id=610735c0&", function () {
      api.rerender('610735c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/modules/orderlist-dialog/cancelOfOrder.vue"
export default component.exports